module.exports = __webpack_public_path__ + "img/zhu_xc9.d1d6b583.jpg";